export default {
    globalAdmin: 'Global Admin',
    localAdmin: 'Regional Admin',
    fleetAdmin: 'Fleet Admin',
    fleetManager: 'Fleet Manager',
    user: 'User',
}
